import { AccountState } from "context/AccountContext";
import { Company } from "models/Company";
import { useEffect, useState } from "react";
import { userAccessService } from "services/Services";
import { useAuth } from "react-oidc-context";

type AccountProps = {
  error: unknown;
  loadingCompanies: boolean;
  getCompanies: () => Promise<Company[] | null>;
  getCurrentCompany(id: string): Promise<Company | null>;
  collectCompanies: () => void;
}

export default function useAccountData():AccountProps {
    const [error, setError] = useState<unknown>();
    const [loadingCompanies, setLoadingCompanies] = useState(true);
    const { stateAccount } = AccountState();
    const auth = useAuth();

    const getCompanies = async() => {
        let companies:(Company[] | null) = null;
        if(stateAccount.companies.length > 0) {
            companies = stateAccount.companies;
        }
        return companies;
    }
    const getCurrentCompany = async(id:string) => {
        let company:(Company | null) = null;
        if(stateAccount.companies.length > 0) {
            const [firstCompany] = stateAccount.companies.filter(x => x.id === id);
            company = firstCompany;
        }
        return company;
    }

    useEffect(() => {
        if(!stateAccount.loadingCompanies) {
            setLoadingCompanies(stateAccount.loadingCompanies);
        }
    }, [stateAccount.loadingCompanies])

    const collectCompanies = async () => {
        if(auth.isAuthenticated) {
            
            if(Object.keys(stateAccount.companies).length === 0) {
                try {
                    const response = await userAccessService.getUserAccess(auth.user?.profile.sub as string);
                    stateAccount.addCompanies(response?.accessList ? response?.accessList as Company[] : []);
                    stateAccount.setLoadingCompanies(false);
                } catch (error) {
                    setError(error);
                    console.log('Ikke kontakt med server');
                }
            }
        }
    }
    return { error, loadingCompanies, getCurrentCompany, getCompanies, collectCompanies};
};